import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';

const Breadcrumb = ({ hierarchy }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const formatPathname = (name) => {
    // Convert path name to a readable format
    return name
      .split('-')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  };

  const handleClick = (index) => {
    // Handle breadcrumb click, you can implement your own logic here
    console.log(`Clicked on breadcrumb ${index}`);
  };

  return (
    <Container>
      <nav aria-label="Breadcrumb" className='mt-5'>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/" style={{ textDecoration: 'none', color:'#e44c23' }}>Home</Link>
          </li>
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            return (
              <li key={name} className={`breadcrumb-item ${isLast ? 'active' : ''}`} aria-current={isLast ? 'page' : null}>
                {isLast ? (
                  formatPathname(name)
                ) : (
                  <Link to={routeTo} onClick={() => handleClick(index)} style={{ textDecoration: 'none' ,color: '#e44c23'}}>
                    {formatPathname(name)}
                  </Link>
                )}
              </li>
            );
          })}
          {hierarchy && (
            <li className="breadcrumb-item active" aria-current="page">
              {hierarchy}
            </li>
          )}
        </ol>
      </nav>
    </Container>
  );
};

export default Breadcrumb;
